<template>
  <section class="product">
    <!-- <p class="subheading">贯彻“素质提高是根本、制度完善是基础、科学管理是关键、技术进步是支撑、安全投入是保障”的系统思维原则</p> -->
    <!-- <h2 class="title">IOT物联网平台</h2>
    <div class="bar">
      <div class="circular"></div>
    </div>
    <p class="subheading">面向工业物联网解决方案的IOT服务</p>-->
    <div class="solution">
      <div class="solution-content">
        <div class="first">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="lock" />
            </div>
            <h3 class="subtitle">业务数据私密性</h3>
            <p class="detailed">
              将系统部署在企业自己
              <span class="block-level distraction">的服务器上，保证</span>
              所有数据资料的私密性；
            </p>
            <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a>
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="second">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="link" />
            </div>
            <h3 class="subtitle">高效与安全性</h3>
            <p class="detailed">
              支持纯内网使用，数据
              <span class="block-level distraction">传输更加迅速，团</span>
              队使用更高效和安全；
              <br />
            </p>
            <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a>
          </div>
        </div>
      </div>
      <div class="solution-content">
        <div class="third">
          <div class="grid-content">
            <div class="icon">
              <v-icon class="flaticon-software" name="clock" />
            </div>
            <h3 class="subtitle">速度最大化</h3>
            <p class="detailed">
              独享服务器保证服务的稳定
              <span class="block-level">性和访问速度最大化，提升</span>
              用户体验，提高工作效率；
            </p>
            <a class="link">
              <v-icon class="more" name="arrow-right" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "product"
};
</script>

<style lang="scss" scoped>
@mixin hover-bg-img {
  background-position: center;
  background-size: calc(100% - 2px) calc(100% - 2px);
  background-repeat: no-repeat;
}

.product {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 70px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 260px) {
    height: 100%;
    .grid-content {
      width: 219px;
    }

    .solution-content {
      padding: 0px;
    }
  }

  @media (max-width: 576px) {
    max-width: 540px;
    padding-right: 0px;
    padding-left: 0px;
    // margin-top: 100px;

    .subheading {
      padding: 0 15px;
    }

    .first {
      @include hover-bg-img;
      background-image: url("../../assets/img/4.jpg");
    }

    .second {
      @include hover-bg-img;
      background-image: url("../../assets/img/5.jpg");
    }

    .third {
      @include hover-bg-img;
      background-image: url("../../assets/img/6.jpg");
    }

    .grid-content {
      color: #ffffff;
      // background-image: linear-gradient(
      //   to bottom right,
      //   rgb(251, 117, 104, 0.6) 9%,
      //   rgba(231, 140, 81, 0.8) 40%,
      //   rgba(249, 169, 87, 0.9) 100%
      // );
      background-image: linear-gradient(
        to bottom right,
        rgb(35, 189, 184, 0.6) 9%,
        rgba(69, 184, 126, 0.8) 40%,
        rgba(67, 231, 148, 0.9) 100%
      );

      .flaticon-software {
        color: #ffffff;
      }

      .detailed {
        color: #ffffff;
      }

      .more {
        color: #44ce6f;
      }
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (max-width: 768px) {
    height: 100%;

    .solution {
      display: inline;
    }
  }

  @media (min-width: 768px) {
    max-width: 740px;
  }

  @media (min-width: 769px) and (max-width: 991px) {
    .grid-content {
      .detailed {
        .distraction {
          line-height: 52px;
        }
      }
    }
  }
  @media (max-width: 992px) {
    .grid-content {
      .detailed {
        .block-level {
          display: inline;
        }
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 880px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.title {
  font-size: 22px;
  margin: 0;
}

.bar {
  height: 4px;
  width: 90px;
  background: #ffe1fd;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular {
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #e36cd9;
    animation: mymove 4s infinite;
    -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/

    @keyframes mymove {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 50px;
  color: #6084a4;
  line-height: 1.9;
}

.solution {
  display: flex;
  margin-bottom: 40px;
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.first {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/4.jpg");
  }
}

.second {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/5.jpg");
  }
}

.third {
  &:hover {
    @include hover-bg-img;
    background-image: url("../../assets/img/6.jpg");
  }
}

.grid-content {
  position: relative;
  padding: 40px 30px;
  text-align: center;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px dashed #cdf1d8;
  margin-bottom: 30px;

  .subtitle {
    font-size: 16px;
    transition: 0.5s;
    margin-top: 20px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
  }

  .detailed {
    margin-top: 0;
    margin-bottom: 20px;
    transition: 0.9s;
    color: #6084a4;
    line-height: 1.9;
    font-size: 14px;
    .block-level {
      display: block;
    }
  }

  .link {
    display: block;
    margin: 0 auto;
    width: 35px;
    height: 35px;
    line-height: 35px;
    color: #0e314c;
    background-color: #f9fafb;
    border-radius: 50%;
    cursor: pointer;
    .more {
      width: 10px;
      height: 35px;
    }
  }

  &:hover {
    color: #ffffff;
    // background-image: linear-gradient(
    //   to bottom right,
    //   rgb(251, 117, 104, 0.6) 9%,
    //   rgba(231, 140, 81, 0.8) 40%,
    //   rgba(249, 169, 87, 0.9) 100%
    // );
    background-image: linear-gradient(
      to bottom right,
      rgb(35, 189, 184, 0.6) 9%,
      rgba(69, 184, 126, 0.8) 40%,
      rgba(67, 231, 148, 0.9) 100%
    );
    // background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);

    .flaticon-software {
      color: #ffffff;
    }

    .detailed {
      color: #ffffff;
    }

    .more {
      color: #44ce6f;
    }
  }
}

.icon {
  display: inline-block;
  width: 70px;
  height: 70px;
  line-height: 86px;
  border: 1px solid #e3f7e9;
  border-radius: 50%;

  .flaticon-software {
    color: #44ce6f;
    width: 30px;
    height: 30px;
  }
}
// .deploy {
//   padding: 70px 10px;
// }

// .title {
//   font-size: 22px;
//   margin: 0px;
// }

// .bar {
//   height: 4px;
//   width: 90px;
//   background: #cdf1d8;
//   margin: 20px auto;
//   position: relative;
//   border-radius: 40px;

//   .circular {
//     position: absolute;
//     left: 0;
//     top: -3.2px;
//     height: 10px;
//     width: 10px;
//     border-radius: 50%;
//     background: #44ce6f;
//     animation: mymove 4s infinite;
//     -webkit-animation: mymove 4s infinite; /*Safari and Chrome both*/

//     @keyframes mymove {
//       from {
//         left: 0px;
//       }

//       to {
//         left: 82px;
//       }
//     }

//     @-webkit-keyframes mymove /*Safari and Chrome*/ {
//       from {
//         left: 0px;
//       }

//       to {
//         left: 82px;
//       }
//     }
//   }
// }

// .subheading {
//   font-size: 14px;
//   max-width: 520px;
//   margin: 0 auto;
//   margin-bottom: 50px;
//   color: #6084a4;
//   line-height: 1.9;
//   padding: 0 15px;
// }

// .content {
//   position: relative;
//   width: 100%;
//   padding-right: 15px;
//   padding-left: 15px;
//   margin-right: auto;
//   margin-left: auto;
//   @media (max-width: 576px) {
//     padding: 0px;
//   }

//   @media (min-width: 577px) and (max-width: 1199px) {
//     max-width: 560px;
//     padding: 0px;
//     text-align: center;
//   }
//   @media (min-width: 1200px) {
//     max-width: 680px;
//   }

//   .detailed {
//     display: block;
//     text-align: left;
//     color: #6084a4;
//     text-indent: 25px;
//     line-height: 1.9;
//   }
// }
</style>